<script setup lang="ts">
import type { LegacyAriaBoolean, LegacyClassBinding } from '@/components/current-student-advanced-standing-form/shared/types'

defineProps<{
  steps: readonly string[]
  applicationComplete: boolean
  stepClass: (index: number) => LegacyClassBinding
  stepAriaDisabled: (index: number) => LegacyAriaBoolean
  stepAriaSelected: (index: number) => LegacyAriaBoolean
  onStepClick: (index: number, event: MouseEvent) => void
}>()
</script>

<template>
  <div class="steps clearfix">
    <ul role="tablist">
      <li
        v-for="(step, index) in steps"
        :key="step"
        role="tab"
        :class="stepClass(index)"
        :aria-disabled="stepAriaDisabled(index)"
        :aria-selected="stepAriaSelected(index)"
      >
        <a :href="applicationComplete ? undefined : `#step-${index + 1}`" @click="onStepClick(index, $event)">
          <span class="number">{{ index + 1 }}.</span> {{ step }}
        </a>
      </li>
    </ul>
  </div>
</template>
